import * as React from 'react';
import PropTypes from 'prop-types';
import { alpha } from '@mui/material/styles';
import { makeStyles } from '@material-ui/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import DeleteIcon from '@mui/icons-material/Delete';
import { visuallyHidden } from '@mui/utils';
import { getTimeSpan, updateIsActiveTimeSpan, updateReservationTimeSpan } from '../../api/routes';
import { useEffect, useState } from 'react';
import MDButton from '../../components/MDButton';
import EditIcon from '@mui/icons-material/Edit';
import { toast } from "react-toastify";

function createData(timeSpanId, requestGroup, subRequestGroup, startTime, endTime, endReservation, patientNumber, isActive, edit) {
    return {
        timeSpanId,
        requestGroup,
        subRequestGroup,
        startTime,
        endTime,
        endReservation,
        patientNumber,
        isActive,
        edit
    };
}


function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}


function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}
const useStyles = makeStyles({
    table: {
        width: '100%',
        display: "flex",
        flexDirection: 'column'
    },
    tableHead: {
        display: "flex",
        width: '100%'
    },
    tableBody: {
        width: '100%',
        display: "flex",
        flexDirection: 'column'
    },
    tableRow: {
        width: '100%'
    }
})
const headCells = [
    {
        id: 'requestGroup',
        numeric: false,
        disablePadding: false,
        label: 'گروه',
    },
    {
        id: 'subRequestGroup',
        numeric: false,
        disablePadding: false,
        label: 'زیر گروه',
    },
    {
        id: 'startTime',
        numeric: true,
        disablePadding: false,
        label: 'زمان شروع',
    },
    {
        id: 'endTime',
        numeric: true,
        disablePadding: false,
        label: 'زمان پایان',
    },
    {
        id: 'endReservation',
        numeric: true,
        disablePadding: false,
        label: 'زمان توقف نوبت دهی',
    },
    {
        id: 'patientNumber',
        numeric: true,
        disablePadding: false,
        label: 'تعداد بیمار',
    },
    {
        id: 'isActive',
        numeric: true,
        disablePadding: false,
        label: 'وضعیت نوبت دهی',
    },
    {
        id: 'edit',
        numeric: false,
        disablePadding: false,
        label: '',
    },
];

function EnhancedTableHead(props) {
    const classes = useStyles();

    const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } =
        props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow className={classes.tableHead}>
                <TableCell padding="checkbox">
                    <Checkbox
                        color="primary"
                        indeterminate={numSelected > 0 && numSelected < rowCount}
                        checked={rowCount > 0 && numSelected === rowCount}
                        onChange={onSelectAllClick}
                        inputProps={{
                            'aria-label': 'select all desserts',
                        }}
                    />
                </TableCell>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={'center'}
                        padding={'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                        sx={{ width: '200px' }}>
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <Box component="span" sx={visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </Box>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};


export default function EnhancedTable({ callback }) {
    const classes = useStyles();
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('');
    const [selected, setSelected] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const [timeSpan, setTimeSpan] = useState([])

    const deleteScenario = (timeSpanId) => {
        const data = {
            timeSpanId,
            del: 1
        }
        updateReservationTimeSpan(data, (isOk, data) => {
            if (!isOk) return toast.error(data.message);
            else return window.location.reload();
        })
    }
    const editScenario = (item) => {
        callback(item)
    }
    /* ------------------------------ */
    const EnhancedTableToolbar = (props) => {
        const { numSelected } = props;

        return (
            <>
                <Toolbar
                    sx={{
                        pl: { sm: 2 },
                        pr: { xs: 1, sm: 1 },
                        ...(numSelected > 0 && {
                            bgcolor: (theme) =>
                                alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
                        }),
                    }}
                >
                    {numSelected > 0 ? (
                        <Typography
                            sx={{ flex: '1 1 100%' }}
                            color="inherit"
                            variant="subtitle1"
                            component="div"
                        >
                            {numSelected} تا انتخاب شده
                        </Typography>
                    ) : (
                        <Typography
                            sx={{ flex: '1 1 100%' }}
                            variant="h6"
                            id="tableTitle"
                            component="div"
                        >
                            بازه زمانی سناریو
                        </Typography>
                    )}
                </Toolbar>
                <MDButton variant="gradient" onClick={() => selected.length > 0 && updateActiveTimeStamp(0)} color="primary" sx={{ margin: '0 1rem' }}>
                    غیر فعال کردن انتخاب شده ها
                </MDButton>
                <MDButton variant="gradient" onClick={() => selected.length > 0 && updateActiveTimeStamp(1)} color="info">
                    فعال کردن انتخاب شده ها
                </MDButton>
            </>
        );
    };
    /* ------------------------ */
    useEffect(() => {
        getTimeSpan(0,(isOk, data) => {
            if (!isOk) return toast.error(data.message);
            else return setTimeSpan(data)
        })
    }, [])
    const rows = timeSpan.map(item => createData(item.timeSpanId, item.nameGroup, item.subNameGroup, item.startTime, item.endTime, item.endReservationTime, item.patientNumber, item.isActive, <><DeleteIcon onClick={() => deleteScenario(item.timeSpanId)} /><EditIcon sx={{ marginLeft: '0.5rem' }} onClick={() => editScenario(item)} /></>))

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = rows.map((n) => n.timeSpanId);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, timeSpanId) => {
        const selectedIndex = selected.indexOf(timeSpanId);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, timeSpanId);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setSelected(newSelected);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const isSelected = (timeSpanId) => selected.indexOf(timeSpanId) !== -1;

    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

    const updateActiveTimeStamp = (isActive) => {
        const data = {
            timeSpanIdArray: selected,
            isActive
        }
        updateIsActiveTimeSpan(data, (isOk, data) => {
            if (!isOk) return toast.error(data.message);
            else return window.location.reload();
        })
    }
    return (
        <>
        <Box sx={{ width: '100%' }}>
            <Paper sx={{ width: '100%', mb: 6 }}>
                <EnhancedTableToolbar numSelected={selected.length} />
                <TableContainer>
                    <Table
                        className={classes.table}
                        aria-labelledby="tableTitle"
                        size={'medium'}
                    >
                        <EnhancedTableHead
                            numSelected={selected.length}
                            order={order}
                            orderBy={orderBy}
                            onSelectAllClick={handleSelectAllClick}
                            onRequestSort={handleRequestSort}
                            rowCount={rows.length}
                        />
                        <TableBody className={classes.tableBody}>
                            {stableSort(rows, getComparator(order, orderBy))
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((row, index) => {
                                    const isItemSelected = isSelected(row.timeSpanId);
                                    const labelId = `enhanced-table-checkbox-${index}`;

                                    return (
                                        <TableRow
                                            className={classes.tableRow}
                                            hover
                                            role="checkbox"
                                            aria-checked={isItemSelected}
                                            tabIndex={-1}
                                            key={row.timeSpanId}
                                            selected={isItemSelected}
                                        >
                                            <TableCell padding="checkbox">
                                                <Checkbox
                                                    onClick={(event) => handleClick(event, row.timeSpanId)}
                                                    color="primary"
                                                    checked={isItemSelected}
                                                    inputProps={{
                                                        'aria-labelledby': labelId,
                                                    }}
                                                />
                                            </TableCell>
                                            <TableCell
                                                component="th"
                                                id={labelId}
                                                scope="row"
                                                padding="none"
                                                sx={{ width: '170px' }} align="center"
                                            >
                                                {row.requestGroup}
                                            </TableCell>
                                            <TableCell sx={{ width: '215px' }} align="center">{row.subRequestGroup}</TableCell>
                                            <TableCell sx={{ width: '170px' }} align="center">{row.startTime}</TableCell>
                                            <TableCell sx={{ width: '200px' }} align="center">{row.endTime}</TableCell>
                                            <TableCell sx={{ width: '200px' }} align="center">{row.endReservation}</TableCell>
                                            <TableCell sx={{ width: '200px' }} align="center">{row.patientNumber}</TableCell>
                                            <TableCell sx={{ width: '200px' }} align="center">{row.isActive ? 'فعال' : 'غیر فعال'}</TableCell>
                                            <TableCell sx={{ width: '200px' }} align="center">{row.edit}</TableCell>
                                        </TableRow>
                                    );
                                })}
                            {emptyRows > 0 && (
                                <TableRow
                                    style={{
                                        height: 53 * emptyRows,
                                    }}
                                >
                                    <TableCell colSpan={6} />
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[20, 30, 40]}
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
        </Box>
        </>
    );
}
